// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3yt5P","content":"styles_content__380I7","intro":"styles_intro__3BduG"};